import {
  useHelpHomeController,
  useHelpTopController,
} from "./use-help-top-controller";
import "./top.scss";
import { HelpHeader } from "../../../organisms/help/header/header";
import {
  TroubleshootingContent,
  TemplateContent,
  BeginnerGuideContent,
  TrainingContent,
  NewFunctionContent,
  VideoContent,
  ReleaseNoteContent,
  ProductInformationContent,
  PaidOptionContent,
  SecurityContent,
  ContractContent,
  SupportContent,
  MailLetterContent,
  GovtechTrendsContent,
} from "../../../organisms/help/category/category";
import { Notification } from "../../../organisms/help/category/notification";
import { ProductSearchFunction } from "../../../organisms/help/category/product-search-function";
import { SearchResults } from "../../../organisms/help/search-results/search-results";
import { HelpTemplate } from "../../../template/help/default-template";
import { Suspense } from "react";
import { Spinner } from "@graffer-inc/console-design-kit";
import React from "react";

const Home: React.FC = () => {
  const { productListResult, categoryListResult, ref } =
    useHelpHomeController();
  const { categoryList } = categoryListResult;
  const isLoading = productListResult.isLoading || categoryListResult.isLoading;

  return (
    <>
      {isLoading ? (
        <Spinner loading={true} />
      ) : (
        <div className="help-top-container" ref={ref}>
          <Notification categoryList={categoryList} />
          <TroubleshootingContent categoryList={categoryList} />
          <TemplateContent categoryList={categoryList} />
          <BeginnerGuideContent categoryList={categoryList} />
          <TrainingContent categoryList={categoryList} />
          <NewFunctionContent categoryList={categoryList} />
          <VideoContent categoryList={categoryList} />
          <ProductSearchFunction
            categoryList={categoryList}
            productList={productListResult.productList}
          />
          <div className="help-content-columns">
            <ReleaseNoteContent categoryList={categoryList} columnsNumber={1} />
            <ProductInformationContent
              categoryList={categoryList}
              columnsNumber={1}
            />
            <PaidOptionContent categoryList={categoryList} columnsNumber={1} />
            <SecurityContent categoryList={categoryList} columnsNumber={1} />
            <ContractContent categoryList={categoryList} columnsNumber={1} />
            <SupportContent categoryList={categoryList} columnsNumber={1} />
            <MailLetterContent categoryList={categoryList} columnsNumber={1} />
            <GovtechTrendsContent
              categoryList={categoryList}
              columnsNumber={1}
            />
          </div>
          <div className="disclaimer-text">
            当サイト上の全ての掲載情報は、あくまで掲載時点における情報であり、当サイト上の全ての掲載情報及び当サイトのアドレスについて、当社は事前に予告することなく内容等の改変を行ったり、削除することがあります。
          </div>
        </div>
      )}
    </>
  );
};

export const HelpTop = () => {
  const {
    query,
    condition,
    result,
    title,
    tags,
    productId,
    isLoading,
    onChangeSearchCondition,
    onChangeSearchText,
    onChangeTags,
    onChangeProduct,
  } = useHelpTopController();

  return (
    <HelpTemplate>
      <Suspense fallback={<Spinner loading={true} />}>
        <HelpHeader
          title={title}
          condition={condition}
          query={query}
          onChangeSearchCondition={onChangeSearchCondition}
          onChangeSearchText={onChangeSearchText}
        />
        {query.length > 0 ? (
          <SearchResults
            query={query}
            isLoading={isLoading}
            contentsList={result ?? []}
            onChangeProduct={onChangeProduct}
            onChangeTags={onChangeTags}
            selectedTags={tags}
            selectedProductId={productId}
          />
        ) : (
          <Home />
        )}
      </Suspense>
    </HelpTemplate>
  );
};
